import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const subtareasApi = createApi({
  reducerPath: "subtareasApi",
  baseQuery: baseQuery(`${API_SERVER}/subtareas`),
  tagTypes: ["Subtareas", "PlanTareaSubtareas"],
  endpoints: (builder) => ({
    getSubtareasTarea: builder.query({
      query: (id) => `/tarea/${id}`,
      providesTags: ["Subtareas"],
    }),
    addCrearNuevoTiempo: builder.mutation({
      query: (body) => ({
        url: `/historialTiempo`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    addSubtarea: builder.mutation({
      query: (body) => ({
        url: `/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    updateEstadoSubtarea: builder.mutation({
      query: ({ id, body }) => ({
        url: `/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    updateMostrarArchivo: builder.mutation({
      query: (body) => ({
        url: `/mostrarArchivo`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    updateSubtarea: builder.mutation({
      query: (body) => ({
        url: `/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    updateArchivo: builder.mutation({
      query: (body) => ({
        url: `/archivo`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    deleteArchivo: builder.mutation({
      query: (id) => ({
        url: `/archivo/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Subtareas"],
    }),
    deleteSubtarea: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Subtareas"],
    }),
    deleteSubtareasLote: builder.mutation({
      query: (body) => ({
        url: `/lote`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["Subtareas"],
    }),
    // Subtareas de tipo plan (catálogo de configuración)
    getPlanTareaSubtareas: builder.query({
      query: () => `/planTarea`,
      providesTags: ["PlanTareaSubtareas"],
    }),
    addPlanTareaSubtarea: builder.mutation({
      query: (body) => ({
        url: `/planTarea`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["PlanTareaSubtareas"],
    }),
    deletePlanTareaSubtarea: builder.mutation({
      query: ({ refPlanTipo, nombreRelacion, nombre }) => ({
        url: `/planTarea/${refPlanTipo}/${nombreRelacion}/${nombre}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PlanTareaSubtareas"],
    }),
    // Subtareas de tipo tarea (catálogo de configuración)
    deleteTipoTareaSubtarea: builder.mutation({
      query: ({ nombre, refTipoTarea, tipoTarea }) => ({
        url: `/tipoTarea/${nombre}/${refTipoTarea}/${tipoTarea}`,
        method: "DELETE",
      }),
    }),
    exportSubTareasEmpleado: builder.query({
      query: ({ sucursal, empleado }) => ({
        url: `/exportEmpleado/${sucursal}/${empleado}`,
        method: "GET",
      }),
    }),
    exportSubTareasTodas: builder.query({
      query: ({ sucursal }) => ({
        url: `/exportTodas/${sucursal}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetSubtareasTareaQuery,
  useLazyGetSubtareasTareaQuery,
  useAddCrearNuevoTiempoMutation,
  useUpdateEstadoSubtareaMutation,
  useUpdateArchivoMutation,
  useDeleteArchivoMutation,
  useUpdateMostrarArchivoMutation,
  useDeleteSubtareaMutation,
  useDeleteSubtareasLoteMutation,
  useAddSubtareaMutation,
  useUpdateSubtareaMutation,
  useExportSubTareasEmpleadoQuery,
  useExportSubTareasTodasQuery,
  useLazyExportSubTareasEmpleadoQuery,
  useLazyExportSubTareasTodasQuery,
  useGetPlanTareaSubtareasQuery,
  useAddPlanTareaSubtareaMutation,
  useDeletePlanTareaSubtareaMutation,
  useDeleteTipoTareaSubtareaMutation,
} = subtareasApi;
